<lib-link [link]="ctaLink()" [queryParams]="queryParams()" [queryParamsHandling]="'merge'" (onClick)="ctaClick.emit()">
  <ng-content />
  <div class="px-5">
    <button class="button text-center w-full min-w-44 text-sm" [ngClass]="ctaClasses()">
      {{ ctaLabel() }}
    </button>
  </div>
</lib-link>
